import AddRounded from '@mui/icons-material/AddRounded';
import type { Client } from '@src/clients/domain/Client';
import { Button } from '@src/common/components/button/Button';
import { Menu, MenuItem } from '@src/common/components/Menu';
import { ClientsNavigation } from '@src/routing/ClientsNavigation';
import type { MouseEvent } from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

type Props = {
  agencies: Client[];
};

export const AddAgencyClientMenuButton = ({ agencies }: Props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleMenuClick = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Button
        variant="contained"
        startIcon={<AddRounded />}
        onClick={handleMenuClick}
      >
        {t('addClient')}
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
      >
        {agencies.map((agency) => (
          <MenuItem
            key={agency.id}
            onClick={() =>
              navigate(ClientsNavigation.addAgencyClient.url(agency.id))
            }
          >
            {agency.name}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};
